import graphql from "babel-plugin-relay/macro";

// NOTES
// role: A_5 => Schouwer
export const UserAppPermissionsQuery = graphql`
  query QueriesUserAppPermissionsQuery {
    user {
      id
      email
      firstName
      lastName
      roles(active: true, role: A_5) {
        totalCount
      }
    }
  }
`;
